import { useMemo } from 'react';
import { merge } from 'lodash';
import { fillNullable } from '../../BranchEditing/hooks/usePrepareBranch';

export const INITIAL_VALUE = {
  id: 0,
  messageText: '',
  aadRoles: [
    { id: 0, roleId: 5, title: 'ARM_SUPERUSER', objectId: '' },
    { id: 0, roleId: 1, title: 'ARM_MANAGER', objectId: '' },
  ],
} as {
  [key: string]: any;
};

export const usePrepareSettings = (values: any) =>
  useMemo(() => {
    const data = merge({}, INITIAL_VALUE, values);

    fillNullable(data, ['aadRoles']);

    return data;
  }, [values]);
